//FILTERS IN FOOTER
const footerFilterBMW = document.querySelector("#footer_filter_bmw");
const footerFilterHonda = document.querySelector("#footer_filter_honda");
const footerFilterMini = document.querySelector("#footer_filter_mini");
const footerFilterOpel = document.querySelector("#footer_filter_opel");
const footerFilterAll = document.querySelector("#footer_filter_all");


const filterParamsAll = [
    'godina_od', 'godina_do', 'cena_od', 'cena_do',
    'karoserija', 'gorivo', 'kubikaza_od',
    'kubikaza_do', 'snaga_od', 'snaga_do', 'kilometraza_od',
    'kilometraza_do', 'menjac', 'vrata', 'sedista'
];


footerFilterBMW.addEventListener("click", () => {
    sessionStorage.removeItem('selectedModels');
    filterParamsAll.forEach(param => {
        sessionStorage.removeItem(param);
    });

    sessionStorage.setItem('selectedMarka', 'bmw');
});

footerFilterHonda.addEventListener("click", () => {
    sessionStorage.removeItem('selectedModels');
    filterParamsAll.forEach(param => {
        sessionStorage.removeItem(param);
    });

    sessionStorage.setItem('selectedMarka', 'honda');
});

footerFilterMini.addEventListener("click", () => {
    sessionStorage.removeItem('selectedModels');
    filterParamsAll.forEach(param => {
        sessionStorage.removeItem(param);
    });

    sessionStorage.setItem('selectedMarka', 'mini');
});

footerFilterOpel.addEventListener("click", () => {
    sessionStorage.removeItem('selectedModels');
    filterParamsAll.forEach(param => {
        sessionStorage.removeItem(param);
    });

    sessionStorage.setItem('selectedMarka', 'opel');
});

footerFilterAll.addEventListener("click", () => {
    sessionStorage.removeItem('selectedModels');
    sessionStorage.removeItem('selectedMarka');
    filterParamsAll.forEach(param => {
        sessionStorage.removeItem(param);
    });
});
